import LegalLayout, { Section } from "@/components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" eyebrow="The fine print" lastUpdated="26 Feb 2026">
      <Section heading="1. Acceptance">
        By accessing or using blisson.in, you agree to be bound by these Terms of Service and our
        Privacy Policy. If you do not agree, please do not use our services.
      </Section>

      <Section heading="2. Eligibility">
        You must be at least 18 years old or have parental consent to make purchases on blisson.in.
        Salon Partner program is reserved for verified salon businesses operating in India.
      </Section>

      <Section heading="3. Products & pricing">
        {"• All prices are in Indian Rupees (₹) and include applicable GST.\n• We reserve the right to change prices, product specifications, and availability without prior notice.\n• Product images are representative; actual packaging may vary slightly.\n• Wholesale (salon partner) pricing is visible only to approved salon partners and is governed by the salon partnership agreement."}
      </Section>

      <Section heading="4. Orders & payments">
        {"• An order is confirmed only after successful payment via Razorpay or verified UPI transfer.\n• We reserve the right to refuse or cancel any order for reasons including stock unavailability, pricing errors, or suspected fraud.\n• On cancellation by us, full refund is issued within 5-7 business days to the original payment method."}
      </Section>

      <Section heading="5. Salon Partner Program">
        {"• Approved Salon Partners may purchase under tiered wholesale pricing and slab schemes set by Blisson admin.\n• Slab benefits (MRP access amount, time window, etc.) are governed individually per partner per slab assignment.\n• Blisson reserves the right to suspend or revoke salon partner access in case of misuse, fake re-sale, or breach of these terms."}
      </Section>

      <Section heading="6. Intellectual property">
        All content on blisson.in — including logos, product photography, copy, design — is the
        exclusive property of Blisson Professional. Unauthorised copying, reproduction or
        commercial use is strictly prohibited.
      </Section>

      <Section heading="7. Limitation of liability">
        Blisson shall not be liable for any indirect, incidental, special or consequential damages
        arising from your use of our products or services. Our maximum liability is limited to the
        amount paid for the specific order in question.
      </Section>

      <Section heading="8. Governing law & jurisdiction">
        These Terms are governed by the laws of India. Any disputes shall be subject to the
        exclusive jurisdiction of the courts at Morbi, Gujarat.
      </Section>

      <Section heading="9. Contact">
        For any questions, contact us at theblisson@gmail.com or +91 7383899003.
      </Section>
    </LegalLayout>
  );
}
